export default "__VITE_ASSET__46b3e746__"